import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BLOCKS = [
    { id: 'header', label: 'En-tête / Menu', icon: '🟦' },
    { id: 'hero', label: 'Hero (Bannière)', icon: '🖼️' },
    { id: 'services', label: 'Grille Services', icon: '🛠️' },
    { id: 'about', label: 'À Propos', icon: '📝' },
    { id: 'gallery', label: 'Galerie Photos', icon: '📷' },
    { id: 'testimonials', label: 'Avis Clients', icon: '⭐' },
    { id: 'map', label: 'Carte / Contact', icon: '📍' },
    { id: 'footer', label: 'Pied de Page', icon: '⬛' },
];

export default function CommercialArchitectPage() {
    const navigate = useNavigate();
    const [structure, setStructure] = useState([]);

    const addBlock = (block) => {
        setStructure([...structure, { ...block, uuid: Date.now() + Math.random() }]);
    };

    const removeBlock = (uuid) => {
        setStructure(structure.filter(b => b.uuid !== uuid));
    };

    const moveBlock = (index, direction) => {
        const newStructure = [...structure];
        if (direction === 'up' && index > 0) {
            [newStructure[index], newStructure[index - 1]] = [newStructure[index - 1], newStructure[index]];
        } else if (direction === 'down' && index < newStructure.length - 1) {
            [newStructure[index], newStructure[index + 1]] = [newStructure[index + 1], newStructure[index]];
        }
        setStructure(newStructure);
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#1e293b', color: 'white', fontFamily: 'Inter, sans-serif', display: 'flex' }}>

            {/* Sidebar Tools */}
            <div style={{ width: 300, background: '#0f172a', padding: 20, borderRight: '1px solid rgba(255,255,255,0.1)', display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 30 }}>
                    <button onClick={() => navigate('/commercial/launchpad')} style={{ background: 'transparent', border: 'none', color: 'white', fontSize: '1.2rem', cursor: 'pointer' }}>←</button>
                    <h1 style={{ fontSize: '1.2rem', fontWeight: 800, margin: 0 }}>🏗️ L'Architecte</h1>
                </div>

                <div style={{ flex: 1, overflowY: 'auto' }}>
                    <div style={{ fontSize: '0.9rem', textTransform: 'uppercase', opacity: 0.5, marginBottom: 15, fontWeight: 700 }}>Briques Disponibles</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        {BLOCKS.map(block => (
                            <button
                                key={block.id}
                                onClick={() => addBlock(block)}
                                style={{
                                    padding: '15px', background: '#1e293b', border: '1px solid #334155', borderRadius: 8,
                                    display: 'flex', alignItems: 'center', gap: 10, color: 'white', cursor: 'pointer',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = '#334155'}
                                onMouseLeave={e => e.currentTarget.style.background = '#1e293b'}
                            >
                                <span style={{ fontSize: '1.2rem' }}>{block.icon}</span>
                                <span style={{ fontWeight: 600 }}>{block.label}</span>
                                <span style={{ marginLeft: 'auto', opacity: 0.5 }}>+</span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Canvas Area */}
            <div style={{ flex: 1, padding: 40, overflowY: 'auto', background: '#334155', display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '100%', maxWidth: 800, minHeight: '100%', display: 'flex', flexDirection: 'column' }}>

                    {/* Header of Canvas */}
                    <div style={{ background: 'white', color: 'black', padding: '20px 30px', borderRadius: '12px 12px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontWeight: 800, fontSize: '1.2rem' }}>MAQUETTE DU SITE WEB</div>
                        <div style={{ fontSize: '0.9rem', opacity: 0.6 }}>Structure V1.0</div>
                    </div>

                    {/* Build Area */}
                    <div style={{ flex: 1, background: '#f1f5f9', padding: 20, display: 'flex', flexDirection: 'column', gap: 10, borderRadius: '0 0 12px 12px' }}>

                        {structure.length === 0 && (
                            <div style={{ height: 300, border: '2px dashed #cbd5e1', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
                                Glissez (cliquez sur) les briques ici pour construire le site
                            </div>
                        )}

                        {structure.map((block, index) => (
                            <div key={block.uuid} className="animate-slide-in" style={{
                                background: 'white', padding: 20, borderRadius: 8, boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderLeft: `5px solid ${getColor(block.id)}`
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
                                    <div style={{ width: 40, height: 40, background: '#f8fafc', borderRadius: 8, display: 'grid', placeItems: 'center', fontSize: '1.2rem' }}>{block.icon}</div>
                                    <div style={{ color: '#1e293b', fontWeight: 700 }}>{block.label}</div>
                                </div>

                                <div style={{ display: 'flex', gap: 5 }}>
                                    <button onClick={() => moveBlock(index, 'up')} disabled={index === 0} style={{ padding: '5px 10px', background: 'transparent', border: '1px solid #e2e8f0', borderRadius: 4, cursor: index === 0 ? 'default' : 'pointer', opacity: index === 0 ? 0.3 : 1 }}>⬆️</button>
                                    <button onClick={() => moveBlock(index, 'down')} disabled={index === structure.length - 1} style={{ padding: '5px 10px', background: 'transparent', border: '1px solid #e2e8f0', borderRadius: 4, cursor: index === structure.length - 1 ? 'default' : 'pointer', opacity: index === structure.length - 1 ? 0.3 : 1 }}>⬇️</button>
                                    <button onClick={() => removeBlock(block.uuid)} style={{ padding: '5px 10px', background: '#fee2e2', border: 'none', borderRadius: 4, cursor: 'pointer', color: '#ef4444', marginLeft: 10 }}>🗑️</button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Footer Actions */}
                    {structure.length > 0 && (
                        <div style={{ marginTop: 20, textAlign: 'center' }}>
                            <button style={{ padding: '15px 40px', background: '#22c55e', color: 'white', border: 'none', borderRadius: 50, fontSize: '1.2rem', fontWeight: 800, cursor: 'pointer', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
                                VALIDER LA STRUCTURE ✅
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <style>{`
                .animate-slide-in { animation: slideIn 0.3s ease-out; }
                @keyframes slideIn { from { opacity: 0; transform: translateX(-20px); } to { opacity: 1; transform: translateX(0); } }
            `}</style>
        </div>
    );
}

function getColor(id) {
    switch (id) {
        case 'header': return '#3b82f6';
        case 'hero': return '#8b5cf6';
        case 'footer': return '#1e293b';
        case 'contact': return '#f59e0b';
        default: return '#cbd5e1';
    }
}
